export const scrollWindowToElement = (element: Element, offsetPx: number) => {
  const top = element.getBoundingClientRect().top + window.scrollY - offsetPx;

  window.scrollTo({ top, behavior: "smooth" });
};
